export default {"src":"/_next/static/media/attack-surface-mapping.2c20b0a4.svg","height":310,"width":310,"blurWidth":0,"blurHeight":0};